import tradingContent from './content/trading.json';

const tradingMock = {
    layoutType: 2,
    data: {
        name: 'trading',
        layoutType: 2,
        areasList: [
            {
                id: 'trading-page-area',
                name: 'Content',
                componentName: 'Comp:TradingPage',
                content: JSON.stringify(tradingContent),
            },
        ],
    },
};

export default tradingMock;
